import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import clientForms from './clientForms';
import type { Client } from '../../../common/types/client';
import FormWrapper from '../../../common/components/FormWrapper';

type Props = {
  client: Client;
  updateClient: (client: Client) => void;
};

function ClientForm({ client, updateClient }: Props) {
  return (
    <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
      <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
        {clientForms.map((form) => (
          <FormWrapper key={form.key} form={form} item={client} update={updateClient} />
        ))}
      </Box>
    </Stack>
  );
}

export default ClientForm;
